/**
 * BypassGo branded establishment icon — replaces lucide's <Store/> wherever
 * the design calls for the custom illustration (blue building with windows
 * and pediment). Used in entry cards, headers, etc. Drop-in replacement
 * mimicking a subset of lucide's API (`size`, `className`).
 */
export default function BypassEstablishmentIcon({ size = 24, className = "", alt = "Établissement" }) {
  return (
    <img
      src="/etablissement-icon-blue.png"
      alt={alt}
      width={size}
      height={size}
      className={`inline-block object-contain align-middle ${className}`}
      style={{ width: size, height: size }}
      data-testid="bypass-establishment-icon"
      draggable={false}
    />
  );
}
